import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Board from "@/pages/Board";
import LegalPage from "@/pages/LegalPage";
import { PreviewBadge } from "@/components/PreviewBadge";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/connexion" element={<Login />} />
          <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
              <Route path="/mentions-legales" element={<LegalPage />} />
              <Route path="/espace-client" element={<ProtectedRoute role="client"><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
              <Route path="/paiement/succes" element={<PaymentSuccess />} />
              <Route path="/paiement/annule" element={<PaymentCancel />} />
              <Route path="/bourse" element={<Board />} />
            </Routes>
          </BrowserRouter>
        </ReactLenis>
        <Toaster position="bottom-right" theme="dark" />
        <PreviewBadge />
      </AuthProvider>
    </div>
  );
}

export default App;
